/* eslint-disable prefer-destructuring */
import { getSegmentsDataFromOrder } from '@/utils/flightCardMapping';
import React from 'react';
import PriceDetailsNotification from '../../containers/PriceDetailsNotification';
import { TPriceDetailsProps } from './type';

const PriceDetailsAPi: React.FC<TPriceDetailsProps> = ({
  passenger,
  onCloseButton,
  onNextButton,
  baggagePrice,
  isDesktop,
  isPayment,
  flightPriceDiff,
  priceDetailsObj,
  sx,
  orderData,
  // discountAmount,
}) => {
  const { adt: adult, chd: child, inf: infant } = passenger || {};
  const priceReturn = priceDetailsObj.priceReturn;

  const segmentData = orderData && getSegmentsDataFromOrder({
    orderData,
    type: 'depart',
  });

  const segmentDataReturn = (priceReturn && orderData) ? getSegmentsDataFromOrder({
    orderData,
    type: 'return',
  }) : null;
  if (!priceDetailsObj) return null;

  return (
    <PriceDetailsNotification
      airline={segmentData && segmentData[0]?.airlineName}
      airlineReturn={segmentDataReturn && segmentDataReturn[0].airlineName}
      isRoundTrip={!!priceReturn}
      priceReturn={priceReturn}
      sx={sx}
      adult={adult}
      isDesktop={isDesktop}
      adtFare={priceDetailsObj?.adtFare}
      taxAdt={priceDetailsObj.taxAdt}
      taxChild={priceDetailsObj.taxChild}
      taxInfant={priceDetailsObj.taxInfant}
      child={child}
      chdFare={priceDetailsObj?.chdFare}
      infant={infant}
      onClose={onCloseButton}
      onNext={onNextButton}
      baggagePriceDepart={priceDetailsObj.departBaggagePrice}
      baggagePriceReturn={priceDetailsObj.priceReturn?.returnBaggagePrice || 0}
      taxFee={priceDetailsObj?.taxFee}
      infFare={priceDetailsObj?.infFare}
      baggagePrice={baggagePrice}
      isPayment={isPayment}
      flightPriceDiff={flightPriceDiff}
      discountAmount={priceDetailsObj?.discountAmt}
      isDepart={false}
    />
  );
};

export default React.memo(PriceDetailsAPi);
